import React, { useState } from 'react';
import { Box, Heading, HeadingProps, HStack, Icon, Text, TextProps } from '@medely/ui-kit';
import { HelpCenterLink } from '@mp';

type ProfilePerformanceItemProps = {
  title: HeadingProps['children'];
  description: TextProps['children'];
  count: HeadingProps['children'];
  link: string;
};

export const ProfilePerformanceItem = ({
  title,
  description,
  count,
  link,
}: ProfilePerformanceItemProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <HStack width="100%" my={3}>
      <Heading size="l">{count}</Heading>
      <Box ml={3} flex={1} mt={1}>
        <Box onClick={() => setIsExpanded((isExpanded) => !isExpanded)}>
          <HStack alignItems="center" justifyContent="space-between">
            <Heading size="xs">{title}</Heading>
            {isExpanded ? <Icon name="chevron-down" /> : <Icon name="chevron-up" />}
          </HStack>
        </Box>
        {isExpanded && (
          <Box mt={1.5}>
            <Box>
              <Text size="m" color="text.secondary">
                {description}
              </Text>
            </Box>
            <Box mt={1} testId="performance-item-link">
              <HelpCenterLink text="Learn more" url={link} />
            </Box>
          </Box>
        )}
      </Box>
    </HStack>
  );
};
